import * as actionTypes from './actionTypes'
import store from '../store'
import { pgaTypes } from '../formSections/pga/constantsPGA'
import { getTargetPGAForm } from '../api/getEntrySummaryData'
import { convertFDAFOOItems } from '../formSections/util/assignValues'
import { initializeTargetPGA, initializeTargetPGAWithTemplates } from './initializeValues'
import {savePGAItemField} from "../api/setFormData";
import {deletePgaFormData} from "../api/deleteFormData";

export function updatePGAField(pgaGuid, targetPGA, merchandiseId, field, payload) {
  return {
    type: actionTypes.UPDATE_PGA_FIELD({ pgaGuid, merchandiseId, targetPGA, pgaGuid }),
    payload,
    field,
    pgaGuid,
  }
}

export function savePGAField(pgaGuid, targetPGA, merchandiseId, lineItemIndex, field) {
  return {
    type: actionTypes.SAVE_PGA_FIELD({ pgaGuid, merchandiseId, targetPGA, pgaGuid }),
    field,
    merchandiseId,
    pgaGuid,
  }
}

export function copyPgaItems(pgaGuid, targetPGA, lineItemIndex, merchandiseId, pgaItems) {
  console.log('pgaGuxxid, targetPGA, lineItemIndex, merchandiseId, pgaItems: ', pgaGuid, targetPGA, lineItemIndex, merchandiseId, pgaItems);
    return {
    type: actionTypes.COPY_PGA_FIELD({merchandiseId, pgaGuid, targetPGA}),
    lineItemIndex,
    merchandiseId,
    payload : convertFDAFOOItems(pgaItems,merchandiseId,pgaGuid, targetPGA),
    pgaItems,
    pgaGuid
  }
}

export function updateRepeatedSubField(pgaGuid, targetPGA, merchandiseId, index, field, payload, list,containerCardinality) {
  if(containerCardinality < 0){
    return updateRepeatedField(pgaGuid, targetPGA, merchandiseId, index, field, payload, list);
  }
  return {
    type: actionTypes.UPDATE_REPEATED_SUB_FIELD({ merchandiseId, targetPGA, pgaGuid }),
    index,
    field,
    payload,
    list,
    containerCardinality,
    pgaGuid
  }
}
export function updateRepeatedField(pgaGuid, targetPGA, merchandiseId, index, field, payload, list) {
  return {
    type: actionTypes.UPDATE_REPEATED_FIELD({ merchandiseId, targetPGA, pgaGuid }),
    index,
    field,
    payload,
    list,
    pgaGuid
  }
}

export function saveRepeatedSubField(pgaGuid, targetPGA, merchandiseId, lineItemIndex, index, field, list,containerCardinality) {
  if(containerCardinality < 0){
    return saveRepeatedField(pgaGuid, targetPGA, merchandiseId, lineItemIndex, index, field, list);
  }
  return {
    type: actionTypes.SAVE_REPEATED_SUB_FIELD({ merchandiseId, targetPGA, pgaGuid }),
    index,
    field,
    merchandiseId,
    list,
    containerCardinality,
    pgaGuid
  }
}
export function saveRepeatedField(pgaGuid, targetPGA, merchandiseId, lineItemIndex, index, field, list) {
  return {
    type: actionTypes.SAVE_REPEATED_FIELD({ merchandiseId, targetPGA, pgaGuid }),
    index,
    field,
    merchandiseId,
    list,
    pgaGuid
  }
}

export function addRepeatedSubItem(pgaGuid, targetPGA, merchandiseId, lineItemIndex, list,containerCardinality,initialValues_th) {
  if(containerCardinality < 0){
    return addRepeatedItem(pgaGuid, targetPGA, merchandiseId, lineItemIndex, list);
  }
  return {
    type: actionTypes.ADD_REPEATED_SUB_ITEM({ merchandiseId, targetPGA, pgaGuid }),
    merchandiseId,
    list,
    containerCardinality,
    initialValues_th,
    pgaGuid,
  }
}
export function replaceAllRepeatedItem(pgaGuid, targetPGA, merchandiseId, lineItemIndex, list, newItemsToReplace) {
  return {
    type: actionTypes.REPEATED_ITEM_REPLACE_ALL({ merchandiseId, targetPGA, pgaGuid }),
    merchandiseId,
    list,
    newItemsToReplace,
    pgaGuid,
  }
}

export function addRepeatedItemArray(pgaGuid, targetPGA, merchandiseId, lineItemIndex, list, arrayOfNewItemsToAdd) {
  return {
    type: actionTypes.ADD_REPEATED_ITEM_ARRAY({ merchandiseId, targetPGA, pgaGuid }),
    merchandiseId,
    list,
    arrayOfNewItemsToAdd,
    pgaGuid,
  }

}

export function addRepeatedItem(pgaGuid, targetPGA, merchandiseId, lineItemIndex, list, newItemsToAdd) {
  return {
    type: actionTypes.ADD_REPEATED_ITEM({ merchandiseId, targetPGA, pgaGuid }),
    merchandiseId,
    list,
    newItemsToAdd,
    pgaGuid,
  }
}

export function removeRepeatedSubGroup(pgaGuid, targetPGA, merchandiseId, lineItemIndex, index, list,containerCardinality) {
  if(containerCardinality < 0){
    return removeRepeatedGroup(pgaGuid,targetPGA, merchandiseId, lineItemIndex, index, list)
  }
  return {
    type: actionTypes.REMOVE_REPEATED_SUB_GROUP({ merchandiseId, targetPGA, pgaGuid }),
    payload: index,
    merchandiseId,
    list,
    containerCardinality,
    pgaGuid,
  }
}
export function removeRepeatedSubSubGroup(pgaGuid,targetPGA, merchandiseId,  index, list,containerCardinality,innerContainerCardinality) {
  return {
    type: actionTypes.REMOVE_REPEATED_SUB_SUB_GROUP({ merchandiseId, targetPGA, pgaGuid }),
    payload: index,
    merchandiseId,
    list,
    containerCardinality,
    innerContainerCardinality,
    pgaGuid,
  }
}
export function addRepeatedSubSubItem(pgaGuid,targetPGA, merchandiseId, lineItemIndex, list,containerCardinality,innerContainerCardinality,initialValues_th) {
  return {
    type: actionTypes.ADD_REPEATED_SUB_SUB_ITEM({ merchandiseId, targetPGA, pgaGuid }),
    merchandiseId,
    list,
    containerCardinality,
    innerContainerCardinality,
    initialValues_th,
    pgaGuid,
  }
}
export function updateRepeatedSubSubField(pgaGuid,targetPGA, merchandiseId, index, field, payload, list,containerCardinality,innerContainerCardinality) {
  return {
    type: actionTypes.UPDATE_REPEATED_SUB_SUB_FIELD({ merchandiseId, targetPGA, pgaGuid }),
    index,
    field,
    payload,
    list,
    containerCardinality,
    innerContainerCardinality,
    pgaGuid,
  }
}
export function saveRepeatedSubSubField(pgaGuid,targetPGA, merchandiseId, lineItemIndex, index, field, list,containerCardinality,innerContainerCardinality) {
  return {
    type: actionTypes.SAVE_REPEATED_SUB_SUB_FIELD({ merchandiseId, targetPGA, pgaGuid }),
    index,
    field,
    merchandiseId,
    list,
    containerCardinality,
    innerContainerCardinality,
    pgaGuid,
  }
}
export function removeRepeatedGroup(pgaGuid,targetPGA, merchandiseId, lineItemIndex, index, list) {
  return {
    type: actionTypes.REMOVE_REPEATED_GROUP({ merchandiseId, targetPGA, pgaGuid }),
    payload: index,
    merchandiseId,
    list,
    pgaGuid,
  }
}

//good for doing a ton of things in a PGA at once
export function deleteAndReplaceMultiplePGAValues(pgaGuid,targetPGA, merchandiseId, lineItemIndex, index, list, newListOfItems,alsoAddThisSave) {
  return {
    type: actionTypes.REMOVE_REPEATED_GROUP({ merchandiseId, targetPGA, pgaGuid }),
    payload: index,
    merchandiseId,
    list,
    pgaGuid,
    newListOfItems,
    alsoAddThisSave,
  }
}
//same as above 
export function replaceRepeatedSubGroup(pgaGuid,targetPGA, merchandiseId, containerCardinality, index, listname, newListOfItems,alsoAddThisSave) {
  return {
    type: actionTypes.REPLACE_REPEATED_SUB_GROUP({ merchandiseId, targetPGA, pgaGuid }),
    payload: index,
    merchandiseId,
    listname,
    pgaGuid,
    newListOfItems,
    alsoAddThisSave,
    containerCardinality,
  }
}


export function addRepeatedSection(pgaGuid,targetPGA, merchandiseId, lineItemIndex, sectionConfig) {
  return {
    type: actionTypes.ADD_REPEATED_SECTION({ merchandiseId, targetPGA, pgaGuid }),
    merchandiseId,
    sectionConfig,
    pgaGuid,
  }
}

export function removeRepeatedSection(pgaGuid,targetPGA, merchandiseId, lineItemIndex, index, listArray) {
  return {
    type: actionTypes.REMOVE_REPEATED_SECTION({ merchandiseId, targetPGA, pgaGuid }),
    payload: index,
    merchandiseId,
    listArray,
    pgaGuid,
  }
}

export const togglePGA = (targetPGA, pgaGuid, merchandiseId, loading) => ({
  type: actionTypes.TOGGLE_PGA({ pgaGuid, targetPGA }),
  payload: merchandiseId,
  pgaGuid,
  loading
})

export function togglePGAForm(pgaFlagInfos, merchandiseId = null,pgaGuid, targetPGA, lineItemIndex, 
  additionalPGAOptions,collapsing) {
  
  store.dispatch(togglePGA(targetPGA, pgaGuid, merchandiseId, true))
  
  if(collapsing){
    return store.dispatch(
      initializeTargetPGA(
        targetPGA,
        pgaGuid,
        {
          loading: true,
          pgaGuid,
          merchandiseId
        }
      )
    )
    
  }
  getTargetPGAForm(targetPGA,pgaGuid, merchandiseId, additionalPGAOptions)
    .then(response => {
      //GET_PGA_FORM


      console.log('responxse:y ', response);
      if (!response.data.eventMessage.pgaItems || response.data.eventMessage.pgaItems.length < 3) {//Shortened for FWS/disclaim
        return store.dispatch(
          initializeTargetPGA(
            targetPGA,
            response.data.eventMessage.pgaGuid,
            {
              error: `ERROR: ${targetPGA} information for the associated HTS and Merchandise ID ${merchandiseId} did come with all required PGA Items.`,
              merchandiseId
            }
          )
        )
      }
      pgaGuid = response.data.eventMessage.pgaGuid;
      // if(!originalGuid){
      //   updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, "selectedFormTypes", selectedFormTypes.map(a=>a.pgaType))
      //   updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, "pgaFlagInfos", selectedFormTypes)
      // }

      if(targetPGA === 'NHT_REI' && response?.data?.eventMessage?.pgaItems?.length>0){
        const isConsigneeIndividualNameCNPresent = response?.data?.eventMessage?.pgaItems?.some((itm)=>{
          return 'individualNameCN' === itm?.key
        })
        const isConsigneeTelNumberCNPresent = response?.data?.eventMessage?.pgaItems?.some((itm)=>{
          return 'telNumberCN' ===itm?.key
        })
        const isConsigneeEmailCNPresent = response?.data?.eventMessage?.pgaItems?.some((itm)=>{
          return 'emailCN' === itm?.key
        })
        console.log({isConsigneeIndividualNameCNPresent, isConsigneeTelNumberCNPresent, isConsigneeEmailCNPresent})
        
        if(!isConsigneeIndividualNameCNPresent){
          response.data.eventMessage.pgaItems.push({
              "key": "individualNameCN",
              "dataType": "STRING",
              "isOptional": "Y",
              "uiLabel": "Individual Name",
              "uiInputType": "DISPLAY",
              "uiLabelDesc": "Name of Individual",
              "PGAId": "individualNameCN",
              "isRepeated": "N",
              "lengthClass": "32X"
            })
        }
        
        if(!isConsigneeTelNumberCNPresent){
          response.data.eventMessage.pgaItems.push({
              "key": "telNumberCN",
              "dataType": "STRING",
              "isOptional": "Y",
              "uiLabel": "Telephone Number",
              "uiInputType": "DISPLAY",
              "uiLabelDesc": "Contact Telephone Number",
              "PGAId": "telNumberCN",
              "isRepeated": "N",
              "lengthClass": "15X"
            })
        }
        if(!isConsigneeEmailCNPresent){
          response.data.eventMessage.pgaItems.push({
              "key": "emailCN",
              "dataType": "STRING",
              "isOptional": "Y",
              "uiLabel": "Email",
              "uiInputType": "DISPLAY",
              "uiLabelDesc": "Contact Email Address",
              "PGAId": "emailCN",
              "isRepeated": "N",
              "lengthClass": "50X"
            })
        }


      }
      return store.dispatch(
        initializeTargetPGAWithTemplates(
          targetPGA,
          response.data.eventMessage.pgaGuid || "FAKEGUID_"+targetPGA+merchandiseId,
          convertFDAFOOItems(
            response.data.eventMessage.pgaItems,
            merchandiseId,
            pgaGuid,
            targetPGA
          ),
          response.data.eventMessage.templates
        )
      )
    })
    .catch(err => {
      console.error(`${targetPGA} Errorxx`, err)
      let error = {
        FDAFOOError: null
      }
      console.log('hit error')
      return store.dispatch(
        initializeTargetPGA(
          targetPGA,
          pgaGuid,
          {
            error: `ERROR: Could not retrieve ${targetPGA} information for the associated HTS and Merchandise ID ${merchandiseId}`,
            merchandiseId
          }
        )
      )
    })
}

// CONTAINERS
export function updateContainerPGA(pgaGuid,targetPGA, merchandiseId, index, containerNum) {
  return {
    type: actionTypes.UPDATE_CONTAINER_PGA({ merchandiseId, targetPGA, pgaGuid }),
    payload: containerNum,
    index,
    pgaGuid,
  }
}

export function addContainerPGA(pgaGuid, targetPGA, merchandiseId) {
  return {
    type: actionTypes.ADD_CONTAINER_PGA({ pgaGuid, merchandiseId, targetPGA }),
    pgaGuid,
  }
}

export function removeContainerPGA(pgaGuid, targetPGA, merchandiseId, lineItemIndex, index) {
  return {
    type: actionTypes.REMOVE_CONTAINER_PGA({ merchandiseId, targetPGA, pgaGuid }),
    payload: index,
    merchandiseId,
    pgaGuid
  }
}

export function saveContainerPGA(pgaGuid, targetPGA, merchandiseId, lineItemIndex, index) {
  return {
    type: actionTypes.SAVE_CONTAINER_PGA({ merchandiseId, targetPGA, pgaGuid }),
    payload: index,
    merchandiseId,
    pgaGuid
  }
}

// export function setFdaDisclaimPGA(merchandiseId = null, targetPGA, lineItemIndex, commercialDescription, additionalPGAOptions){
//   getTargetPGAForm(targetPGA,null, merchandiseId, additionalPGAOptions)
//   .then(response => {
//     const PGAItemsArrayUncopied = [
//       {
//         "key": "disclaimCode",
//         "value": "A",
//         "dataType": "STRING",
//         "isOptional": "Y",
//         "uiLabel": "Disclaim Code",
//         "uiInputType": "DISPLAY",
//         "uiLabelDesc": "Disclaim Code",
//         "PGAId": "disclaimCode",
//         "isRepeated": "N",
//         "lengthClass": "1A",
//         "value": "A"
//       },
//       {
//         "key": "disclaimFlag",
//         "dataType": "STRING",
//         "uiLabel": "Disclaim Flag",
//         "uiInputType": "DISPLAY",
//         "uiLabelDesc": "Disclaim Flag",
//         "PGAId": "disclaimFlag",
//         "isRepeated": "N",
//         "value": "Y"
//       }
//     ]
//     savePGAItemField(PGAItemsArrayUncopied, merchandiseId, targetPGA)
//   })
// }
